import React from 'react';
import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Divider,
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useLanguage } from '../contexts/LanguageContext';
import { useLocation } from 'react-router-dom';
import { decodeState } from '../utils/stateManager';
import {
  ALTERNATE_MEXICANO_PAIRING,
  normalizeMexicanoPairing,
} from '../utils/mexicano';

function GameRules() {
  const [open, setOpen] = React.useState(false);
  const { translate } = useLanguage();
  const location = useLocation();

  const { format, mexicanoPairing } = React.useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    const encodedState = searchParams.get('state');
    if (encodedState) {
      const decoded = decodeState(encodedState);
      return {
        format: decoded?.format || 'americano',
        mexicanoPairing: normalizeMexicanoPairing(decoded?.mexicanoPairing),
      };
    }

    const fromUrl = (searchParams.get('format') || '').toLowerCase();
    return {
      format: fromUrl === 'mexicano' ? 'mexicano' : 'americano',
      mexicanoPairing: normalizeMexicanoPairing(searchParams.get('mexicanoPairing')),
    };
  }, [location.search]);

  const isMexicano = format === 'mexicano';
  const mexicanoPatternKey = mexicanoPairing === ALTERNATE_MEXICANO_PAIRING
    ? 'rules.teamPattern14v23'
    : 'rules.teamPattern13v24';

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <IconButton onClick={handleOpen} size="large" color="primary" aria-label={translate('rules.titleAmericano')}>
        <HelpOutlineIcon />
      </IconButton>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {isMexicano ? translate('rules.titleMexicano') : translate('rules.titleAmericano')}
        </DialogTitle>
        <DialogContent>
          <Typography paragraph>
            <strong>{translate('rules.teamSetupTitle')}:</strong>{' '}
            {isMexicano
              ? translate('rules.teamSetupMexicano', {
                  pattern: translate(mexicanoPatternKey),
                })
              : translate('rules.teamSetupAmericano')}
          </Typography>
          <Typography paragraph>
            <strong>{translate('rules.scoringSystemTitle')}:</strong> {translate('rules.scoringSystem')}
          </Typography>
          <Typography paragraph>
            <strong>{translate('rules.winnerTitle')}:</strong> {translate('rules.winner')}
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1.5 }}>
            {translate('rules.faqTitle')}
          </Typography>
          {[
            ['rules.faqFormatsQ', 'rules.faqFormatsA'],
            ['rules.faqSportsQ', 'rules.faqSportsA'],
            ['rules.faqFreeQ', 'rules.faqFreeA'],
            ['rules.faqPlayersQ', 'rules.faqPlayersA'],
          ].map(([q, a]) => (
            <Typography key={q} paragraph>
              <strong>{translate(q)}</strong><br />
              {translate(a)}
            </Typography>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{translate('common.close')}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default GameRules;
